// Deckbuilder JavaScript Functionality

document.addEventListener('DOMContentLoaded', function() {
  const deckInput = document.getElementById('deck-input');
  const searchBtn = document.getElementById('search-deck');
  const clearBtn = document.getElementById('clear-deck');
  const resultsSection = document.getElementById('results-section');
  const resultsGrid = document.getElementById('results-grid');
  const loadingIndicator = document.getElementById('loading-indicator');
  const addAllBtn = document.getElementById('add-all-to-cart');
  const missingCardsSection = document.getElementById('missing-cards');
  const missingList = document.getElementById('missing-list');
  const backBtn = document.getElementById('back-to-deckbuilder');
  const inputSection = document.querySelector('.deckbuilder-input-section');
  const vendorSelect = document.getElementById('vendor-select');

  // Stats elements
  const lineCount = document.getElementById('line-count');
  const cardCount = document.getElementById('card-count');
  const foundCount = document.getElementById('found-count');
  const missingCount = document.getElementById('missing-count');
  const totalPrice = document.getElementById('total-price');

  let searchResults = [];
  let missingCards = [];
  let totalCost = 0;

  // Alternatives (modal) state
  const ALTERNATIVES_PER_PAGE = 12;
  let alternativesState = null;
  const MIX_CONDITIONS_STORAGE_KEY = 'deckbuilderMixConditionsEnabled';
  const productDataCache = new Map();
  const variantInventoryCache = new Map(); // variantId -> known remaining inventory or null
  const TOAST_TIMEOUT_MS = 3200;
  const CART_ADD_RETRY_ATTEMPTS = 4;
  const CART_ADD_CHUNK_SIZE = 12;
  const SEARCH_CONCURRENCY = 8;
  const STOCK_HYDRATION_CONCURRENCY = 4;
  const CONDITION_PRIORITY = [
    'near mint',
    'near mint foil',
    'lightly played',
    'lightly played foil',
    'moderately played',
    'moderately played foil',
    'heavily played',
    'heavily played foil',
    'damaged',
    'damaged foil'
  ];
  let activeSearchRunId = 0;

  // Check for data from mini deckbuilder
  const urlParams = new URLSearchParams(window.location.search);
  const fromMini = urlParams.get('from-mini');
  const quickSearch = urlParams.get('quick-search');

  if (fromMini || quickSearch) {
    const miniData = sessionStorage.getItem('miniDeckbuilderData');
    if (miniData) {
      try {
        const data = JSON.parse(miniData);

        // Populate the deck input
        if (data.cards) {
          deckInput.value = data.cards;
        }

        // Set collection if provided
        if (data.collection && vendorSelect) {
          vendorSelect.value = data.collection;
        }

        // Clear the session storage
        sessionStorage.removeItem('miniDeckbuilderData');

        // Update stats
        updateInputStats();

        // If quick search, automatically trigger search
        if (quickSearch) {
          setTimeout(() => {
            searchBtn.click();
          }, 100);
        } else {
          // Show a notification that data was transferred
          const notification = document.createElement('div');
          notification.className = 'transfer-notification';
          notification.innerHTML = `
            <div class="notification-content">
              <svg width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path>
              </svg>
              <span>Deck data transferred from Quick Check!</span>
            </div>
          `;
          document.body.appendChild(notification);

          setTimeout(() => {
            notification.classList.add('show');
          }, 100);

          setTimeout(() => {
            notification.classList.remove('show');
            setTimeout(() => {
              notification.remove();
            }, 300);
          }, 3000);
        }
      } catch (e) {
        console.error('Error parsing mini deckbuilder data:', e);
      }
    }
  }

  // Update input stats in real-time
  deckInput.addEventListener('input', updateInputStats);

  function updateInputStats() {
    const lines = deckInput.value.trim().split('\n').filter(line => line.trim());
    const totalCards = lines.reduce((sum, line) => {
      const match = line.trim().match(/^(\d+)\s+(.+)$/);
      return sum + (match ? parseInt(match[1]) : 1); // Default to 1 if no quantity found
    }, 0);

    lineCount.textContent = `${lines.length} lines`;
    cardCount.textContent = `${totalCards} cards total`;
  }

  // Clear deck functionality
  clearBtn.addEventListener('click', function() {
    deckInput.value = '';
    updateInputStats();
    hideResults();
  });

  // Search deck functionality
  searchBtn.addEventListener('click', function() {
    const deckList = parseDeckList(deckInput.value);
    if (deckList.length === 0) {
      showDeckbuilderToast('Please enter a deck list first.', 'warning');
      return;
    }
    searchCards(deckList);
  });

  // Add all to cart functionality
  addAllBtn.addEventListener('click', function() {
    addAllFoundCardsToCart();
  });

  // Back to deckbuilder functionality
  backBtn.addEventListener('click', function() {
    showInputSection();
    hideResults();
  });

  function parseDeckList(input) {
    const lines = input.trim().split('\n').filter(line => line.trim());
    const deckList = [];

    lines.forEach(line => {
      const trimmed = line.trim();
      // First try to match with quantity
      const matchWithQty = trimmed.match(/^(\d+)\s+(.+)$/);
      
      if (matchWithQty) {
        const quantity = parseInt(matchWithQty[1]);
        const cardName = matchWithQty[2].trim();
        deckList.push({ quantity, cardName, originalLine: trimmed });
      } else {
        // No quantity found, default to 1
        const cardName = trimmed;
        deckList.push({ quantity: 1, cardName, originalLine: trimmed });
      }
    });

    return deckList;
  }

  function getSearchCacheKey(cardName, selectedCollection) {
    return `${String(selectedCollection || '').toLowerCase()}::${String(cardName || '').trim().toLowerCase()}`;
  }

  async function runWithConcurrency(items, concurrency, worker) {
    const results = new Array(items.length);
    let nextIndex = 0;

    const workerCount = Math.max(1, Math.min(concurrency, items.length || 1));
    const workers = Array.from({ length: workerCount }, async () => {
      while (nextIndex < items.length) {
        const currentIndex = nextIndex++;
        results[currentIndex] = await worker(items[currentIndex], currentIndex);
      }
    });

    await Promise.all(workers);
    return results;
  }

  async function hydrateVisibleStockInBackground(runId, renderWhenDone = true) {
    const indices = searchResults
      .map((_, index) => index)
      .filter(index => {
        const result = searchResults[index];
        return result && result.found !== false && result.stockStatus === 'pending';
      });

    await runWithConcurrency(indices, STOCK_HYDRATION_CONCURRENCY, async (index) => {
      if (runId !== activeSearchRunId) return;
      const result = searchResults[index];
      if (!result) return;

      try {
        const productData = await getProductDataForResult(result);
        if (runId !== activeSearchRunId || !productData || !Array.isArray(productData.variants)) return;

        const selectedVariant = productData.variants.find(v => String(v.id) === String(result.variantId)) || getPreferredVariant(productData.variants);
        if (!selectedVariant) return;

        searchResults[index] = {
          ...result,
          product: productData,
          variant: selectedVariant,
          variantId: selectedVariant.id,
          price: Number(selectedVariant.price || 0) / 100,
          stockStatus: 'hydrated'
        };
      } catch (error) {
        // Keep initial result visible if hydration fails.
      }
    });

    if (renderWhenDone && runId === activeSearchRunId) {
      displayResults();
    }
  }

  async function searchCards(deckList) {
    const runId = ++activeSearchRunId;
    showLoading();
    searchResults = [];
    missingCards = [];
    totalCost = 0;

    try {
      const selectedCollection = vendorSelect ? vendorSelect.value : '';
      const cacheByKey = new Map();
      deckList.forEach(card => {
        const key = getSearchCacheKey(card.cardName, selectedCollection);
        if (!cacheByKey.has(key)) {
          cacheByKey.set(key, { cardName: card.cardName });
        }
      });

      const uniqueLookups = Array.from(cacheByKey.entries()).map(([key, value]) => ({ key, cardName: value.cardName }));
      let completed = 0;

      const uniqueResults = await runWithConcurrency(uniqueLookups, SEARCH_CONCURRENCY, async (lookup) => {
        const result = await searchSingleCard(lookup.cardName, 1);
        completed += 1;
        if (runId === activeSearchRunId) {
          searchBtn.textContent = `Searching ${completed}/${uniqueLookups.length}...`;
        }
        return { key: lookup.key, result };
      });

      if (runId !== activeSearchRunId) return;

      const resolvedByKey = new Map(uniqueResults.map(entry => [entry.key, entry.result]));

      for (const card of deckList) {
        const key = getSearchCacheKey(card.cardName, selectedCollection);
        const result = resolvedByKey.get(key);

        if (result && result.found) {
          searchResults.push({
            ...result,
            quantity: card.quantity,
            originalLine: card.originalLine,
            originalCardName: card.cardName,
            stockStatus: 'pending'
          });
          totalCost += result.price * card.quantity;
        } else {
          missingCards.push({
            cardName: card.cardName,
            quantity: card.quantity,
            originalLine: card.originalLine
          });
        }
      }

      if (runId === activeSearchRunId) {
        if (missingCards.length === 0) {
          searchBtn.textContent = 'All cards found. Checking stock...';
        } else {
          searchBtn.textContent = `Found ${searchResults.length}/${deckList.length}. Checking stock...`;
        }
      }

      // Keep the loading state visible until stock hydration completes.
      // This avoids an intermediate "checking stock..." render pass.
      await hydrateVisibleStockInBackground(runId, false);
      if (runId === activeSearchRunId) {
        displayResults();
      }
    } catch (error) {
      console.error('Search error:', error);
      showDeckbuilderToast('Error searching for cards. Please try again.', 'error');
    } finally {
      if (runId === activeSearchRunId) {
        hideLoading();
      }
    }
  }

  async function searchSingleCard(cardName, quantity) {
    try {
      const vendorSelect = document.getElementById('vendor-select');
      const selectedCollection = vendorSelect.value;
      
      let searchQuery = encodeURIComponent(cardName);
      let searchUrl;
      
      if (selectedCollection) {
        // Use global search but filter by collection
        searchUrl = `/search/suggest.json?q=${searchQuery}&resources[type]=product&resources[limit]=50`;
      } else {
        // Use global search API
        searchUrl = `/search/suggest.json?q=${searchQuery}&resources[type]=product&resources[limit]=10`;
      }

      const response = await fetch(searchUrl);
      const data = await response.json();

      if (data.resources && data.resources.results && data.resources.results.products && data.resources.results.products.length > 0) {
        let products = data.resources.results.products;
        
        // If collection is selected, filter products by collection
        if (selectedCollection) {
          // Filter by checking if product URL contains collection handle
          products = products.filter(product => {
            // Check if product belongs to the selected collection
            return product.url && product.url.includes(`/collections/${selectedCollection}/`);
          });
          
          // If no products found in collection, try alternative filtering
          if (products.length === 0) {
            // Try searching with collection name in query
            const collectionName = getCollectionDisplayName(selectedCollection);
            const collectionSearchUrl = `/search/suggest.json?q=${searchQuery}+${encodeURIComponent(collectionName)}&resources[type]=product&resources[limit]=20`;
            
            try {
              const collectionResponse = await fetch(collectionSearchUrl);
              const collectionData = await collectionResponse.json();
              if (collectionData.resources && collectionData.resources.results && collectionData.resources.results.products) {
                products = collectionData.resources.results.products;
              }
            } catch (e) {
              console.log('Collection search fallback failed, using original results');
              products = data.resources.results.products;
            }
          }
        }
        
        if (products.length > 0) {
          // Find the best match
          const bestMatch = findBestMatch(products, cardName);
          
          if (bestMatch) {
            // Get product details
            const productResponse = await fetch(`/products/${bestMatch.handle}.js`);
            const productData = await productResponse.json();
            if (!productData.handle) productData.handle = bestMatch.handle;
            productDataCache.set(productData.handle, productData);
            
            // Find best available variant based on condition priority
            const availableVariant = getPreferredVariant(productData.variants);
            
            if (availableVariant) {
              return {
                found: true,
                product: productData,
                variant: availableVariant,
                title: productData.title,
                price: availableVariant.price / 100, // Convert from cents
                image: productData.featured_image,
                url: `/products/${productData.handle}`,
                variantId: availableVariant.id
              };
            }
          }
        }
      }

      return { found: false, cardName };
    } catch (error) {
      console.error('Error searching for card:', cardName, error);
      return { found: false, cardName };
    }
  }

  function getCollectionDisplayName(handle) {
    const collectionNames = {
      'magic-the-gathering': 'Magic The Gathering',
      'pokemon': 'Pokemon',
      'flesh-blood': 'Flesh Blood',
      'grand-archive': 'Grand Archive',
      'star-wars-unlimited': 'Star Wars',
      'one-piece': 'One Piece',
      'lorcana': 'Lorcana',
      'hololive': 'Hololive',
      'godzilla': 'Godzilla',
      'topps': 'Topps',
      'sorcery': 'Sorcery'
    };
    return collectionNames[handle] || handle;
  }

  function findBestMatchFromProducts(products, searchTerm) {
    const searchLower = searchTerm.toLowerCase();
    
    // Exact match first
    let exactMatch = products.find(p => p.title.toLowerCase() === searchLower);
    if (exactMatch) return exactMatch;

    // Contains match
    let containsMatch = products.find(p => p.title.toLowerCase().includes(searchLower));
    if (containsMatch) return containsMatch;

    // Word match
    const searchWords = searchLower.split(' ');
    let wordMatch = products.find(p => {
      const titleLower = p.title.toLowerCase();
      return searchWords.every(word => titleLower.includes(word));
    });
    if (wordMatch) return wordMatch;

    // Return first result as fallback
    return products[0];
  }

  function findBestMatch(products, searchTerm) {
    const searchLower = searchTerm.toLowerCase();
    
    // Exact match first
    let exactMatch = products.find(p => p.title.toLowerCase() === searchLower);
    if (exactMatch) return exactMatch;

    // Contains match
    let containsMatch = products.find(p => p.title.toLowerCase().includes(searchLower));
    if (containsMatch) return containsMatch;

    // Word match
    const searchWords = searchLower.split(' ');
    let wordMatch = products.find(p => {
      const titleLower = p.title.toLowerCase();
      return searchWords.every(word => titleLower.includes(word));
    });
    if (wordMatch) return wordMatch;

    // Return first result as fallback
    return products[0];
  }

  function normalizeVariantTitle(title) {
    return String(title || '').toLowerCase().trim().replace(/\s+/g, ' ');
  }

  function getConditionRank(variantTitle) {
    const normalized = normalizeVariantTitle(variantTitle);

    const exactIdx = CONDITION_PRIORITY.indexOf(normalized);
    if (exactIdx >= 0) return exactIdx;

    for (let i = 0; i < CONDITION_PRIORITY.length; i++) {
      if (normalized.includes(CONDITION_PRIORITY[i])) return i;
    }
    return 999; // Any unlisted variant goes last
  }

  function getPreferredVariant(variants) {
    if (!Array.isArray(variants) || variants.length === 0) return null;
    const available = variants.filter(v => v && v.available);
    if (available.length === 0) return null;

    available.sort((a, b) => {
      const rankDiff = getConditionRank(a.title) - getConditionRank(b.title);
      if (rankDiff !== 0) return rankDiff;
      return normalizeVariantTitle(a.title).localeCompare(normalizeVariantTitle(b.title));
    });

    return available[0];
  }

  function ensureMixToggleUi() {
    if (document.getElementById('mix-conditions-toggle')) return;
    const summary = document.querySelector('.results-summary');
    if (!summary) return;

    const wrapper = document.createElement('label');
    wrapper.className = 'mix-conditions-toggle';
    wrapper.innerHTML = `
      <input type="checkbox" id="mix-conditions-toggle">
      <span>Allow mixed conditions when adding to cart</span>
      <span
        class="mix-conditions-info"
        tabindex="0"
        aria-label="Mixed conditions help"
        data-tooltip="When enabled, Add to Cart can combine available quantities across multiple conditions (Near Mint, Lightly Played, etc) to fulfill more of your requested cards."
      >ⓘ</span>
    `;

    summary.appendChild(wrapper);

    const checkbox = wrapper.querySelector('#mix-conditions-toggle');
    checkbox.checked = getAllowMixedConditions();
    checkbox.addEventListener('change', function() {
      localStorage.setItem(MIX_CONDITIONS_STORAGE_KEY, checkbox.checked ? '1' : '0');
      updateMixToggleUiState();
    });

    updateMixToggleUiState();
  }

  function getAllowMixedConditions() {
    return localStorage.getItem(MIX_CONDITIONS_STORAGE_KEY) === '1';
  }

  function updateMixToggleUiState() {
    const toggleEl = document.getElementById('mix-conditions-toggle');
    if (!toggleEl) return;
  }

  function getInCartQuantityMap(cart) {
    const qtyMap = new Map();
    const items = (cart && Array.isArray(cart.items)) ? cart.items : [];
    items.forEach(item => {
      const id = String(item.id || '');
      if (!id) return;
      qtyMap.set(id, (qtyMap.get(id) || 0) + Number(item.quantity || 0));
    });
    return qtyMap;
  }

  function getVariantRemainingQty(variant, inCartQty) {
    const policy = String(variant.inventory_policy || '').toLowerCase();
    const isTracked = !!variant.inventory_management;
    const hasKnownInventory = variant.inventory_quantity !== null
      && variant.inventory_quantity !== undefined
      && Number.isFinite(Number(variant.inventory_quantity));
    const inventoryQty = hasKnownInventory ? Number(variant.inventory_quantity) : null;

    // If Shopify exposes a numeric quantity, always cap against it.
    // This prevents over-adds that later get corrected at checkout.
    if (hasKnownInventory) return Math.max(0, inventoryQty - inCartQty);

    // If inventory is not tracked, allow add.
    if (!isTracked) return Number.POSITIVE_INFINITY;

    // Tracked inventory with unknown quantity is unsafe to oversell.
    // Hydration should resolve this in most cases; if not, block over-add.
    if (policy === 'continue') return Number.POSITIVE_INFINITY;
    return 0;
  }

  async function getKnownVariantInventoryFromPage(handle, variantId) {
    const cacheKey = String(variantId);
    if (variantInventoryCache.has(cacheKey)) return variantInventoryCache.get(cacheKey);

    if (!handle || !variantId) {
      variantInventoryCache.set(cacheKey, null);
      return null;
    }

    try {
      const response = await fetch(`/products/${handle}?variant=${variantId}`);
      if (!response.ok) {
        variantInventoryCache.set(cacheKey, null);
        return null;
      }

      const html = await response.text();
      const lowStockMatch = html.match(/inventory-quantity[^>]*>\s*\((\d+)\s*left\)\s*<\/span>/i);
      if (lowStockMatch && lowStockMatch[1]) {
        const qty = Number(lowStockMatch[1]);
        const value = Number.isFinite(qty) ? qty : null;
        variantInventoryCache.set(cacheKey, value);
        return value;
      }

      // If no explicit "(N left)" is rendered, we don't have a trusted number.
      variantInventoryCache.set(cacheKey, null);
      return null;
    } catch (e) {
      variantInventoryCache.set(cacheKey, null);
      return null;
    }
  }

  function buildAddPlan(productData, requestedQty, inCartQtyMap, allowMixedConditions, preferredVariantId = null) {
    const qtyRequested = Math.max(0, Number(requestedQty) || 0);
    if (!productData || !Array.isArray(productData.variants) || qtyRequested === 0) {
      return { lines: [], requestedQty: qtyRequested, addedQty: 0, remainingQty: qtyRequested };
    }

    const variants = productData.variants
      .filter(v => v && v.available)
      .sort((a, b) => {
        const rankDiff = getConditionRank(a.title) - getConditionRank(b.title);
        if (rankDiff !== 0) return rankDiff;
        return normalizeVariantTitle(a.title).localeCompare(normalizeVariantTitle(b.title));
      });

    if (preferredVariantId) {
      const preferredId = String(preferredVariantId);
      variants.sort((a, b) => {
        const aPreferred = String(a.id) === preferredId ? 1 : 0;
        const bPreferred = String(b.id) === preferredId ? 1 : 0;
        return bPreferred - aPreferred;
      });
    }

    const lines = [];
    let needed = qtyRequested;

    for (const variant of variants) {
      if (needed <= 0) break;
      const variantId = String(variant.id);
      const inCart = Number(inCartQtyMap.get(variantId) || 0);
      const remaining = getVariantRemainingQty(variant, inCart);
      const takeQty = Number.isFinite(remaining) ? Math.min(needed, remaining) : needed;

      if (takeQty > 0) {
        lines.push({
          variantId,
          quantity: takeQty,
          variantTitle: variant.title || 'Variant'
        });
        needed -= takeQty;
      }

      if (!allowMixedConditions && lines.length > 0) break;
    }

    const addedQty = lines.reduce((sum, line) => sum + line.quantity, 0);
    return { lines, requestedQty: qtyRequested, addedQty, remainingQty: Math.max(0, qtyRequested - addedQty) };
  }

  function getProductHandleFromResult(result) {
    if (!result) return null;
    if (result.product && result.product.handle) return result.product.handle;
    if (result.url) {
      const match = String(result.url).match(/\/products\/([^/?#]+)/);
      if (match && match[1]) return match[1];
    }
    return null;
  }

  function getProductHandleFromData(productData) {
    if (productData && productData.handle) return productData.handle;
    if (productData && productData.url) {
      const match = String(productData.url).match(/\/products\/([^/?#]+)/);
      if (match && match[1]) return match[1];
    }
    return null;
  }

  async function getProductDataForResult(result) {
    if (!result) return null;
    if (result.product && Array.isArray(result.product.variants) && result.product.variants.length > 0) {
      await hydrateVariantInventory(result.product);
      return result.product;
    }

    const handle = getProductHandleFromResult(result);
    if (!handle) return null;
    if (productDataCache.has(handle)) return productDataCache.get(handle);

    try {
      const response = await fetch(`/products/${handle}.js`);
      if (!response.ok) return null;
      const data = await response.json();
      if (!data.handle) data.handle = handle;
      await hydrateVariantInventory(data);
      productDataCache.set(handle, data);
      return data;
    } catch (e) {
      console.error('Error loading product data for stock checks:', e);
      return null;
    }
  }

  async function hydrateVariantInventory(productData) {
    if (!productData || !Array.isArray(productData.variants)) return;

    const needsHydration = productData.variants.filter(variant => {
      if (!variant || !variant.available) return false;
      const isTracked = !!variant.inventory_management;
      const hasKnownInventory = variant.inventory_quantity !== null
        && variant.inventory_quantity !== undefined
        && Number.isFinite(Number(variant.inventory_quantity));
      return isTracked && !hasKnownInventory;
    });

    if (needsHydration.length === 0) return;

    await Promise.all(needsHydration.map(async (variant) => {
      try {
        const response = await fetch(`/variants/${variant.id}.js`);
        if (!response.ok) return;
        const variantData = await response.json();
        if (variantData && Number.isFinite(Number(variantData.inventory_quantity))) {
          variant.inventory_quantity = Number(variantData.inventory_quantity);
        }
      } catch (e) {
        // Keep variant as-is; fallback logic handles unknown inventory.
      }
    }));

    // Last-resort fallback: parse "Low stock (N left)" from product page HTML for this variant.
    const handle = getProductHandleFromData(productData);
    await Promise.all(needsHydration.map(async (variant) => {
      const hasKnownInventory = variant.inventory_quantity !== null
        && variant.inventory_quantity !== undefined
        && Number.isFinite(Number(variant.inventory_quantity));
      if (hasKnownInventory) return;

      const pageQty = await getKnownVariantInventoryFromPage(handle, variant.id);
      if (pageQty !== null) {
        variant.inventory_quantity = pageQty;
      }
    }));
  }

  async function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  function getRetryDelayMs(response, attemptIndex) {
    const retryAfter = response && response.headers ? response.headers.get('Retry-After') : null;
    if (retryAfter) {
      const parsedSeconds = Number(retryAfter);
      if (Number.isFinite(parsedSeconds) && parsedSeconds > 0) {
        return Math.round(parsedSeconds * 1000);
      }
    }

    const base = 350 * Math.pow(2, attemptIndex);
    const jitter = Math.floor(Math.random() * 180);
    return base + jitter;
  }

  async function addCartItemsWithRetry(items) {
    for (let attempt = 0; attempt < CART_ADD_RETRY_ATTEMPTS; attempt++) {
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({ items })
        });

        if (response.ok) {
          return { ok: true };
        }

        if (response.status === 429 && attempt < CART_ADD_RETRY_ATTEMPTS - 1) {
          await sleep(getRetryDelayMs(response, attempt));
          continue;
        }

        const errorText = await response.text();
        return { ok: false, status: response.status, errorText };
      } catch (error) {
        if (attempt < CART_ADD_RETRY_ATTEMPTS - 1) {
          await sleep(getRetryDelayMs(null, attempt));
          continue;
        }
        return { ok: false, status: 0, errorText: String(error) };
      }
    }

    return { ok: false, status: 0, errorText: 'Retries exhausted' };
  }

  async function addCartItemsInChunks(items) {
    const addedByVariant = new Map();
    const failedItems = [];

    for (let i = 0; i < items.length; i += CART_ADD_CHUNK_SIZE) {
      const chunk = items.slice(i, i + CART_ADD_CHUNK_SIZE);
      const chunkResult = await addCartItemsWithRetry(chunk);

      if (chunkResult.ok) {
        chunk.forEach(item => {
          const key = String(item.id);
          addedByVariant.set(key, Number(addedByVariant.get(key) || 0) + Number(item.quantity || 0));
        });
      } else {
        // Salvage: retry each line independently so one bad line doesn't drop the whole chunk.
        for (const item of chunk) {
          const lineResult = await addCartItemsWithRetry([item]);
          if (lineResult.ok) {
            const key = String(item.id);
            addedByVariant.set(key, Number(addedByVariant.get(key) || 0) + Number(item.quantity || 0));
          } else {
            failedItems.push(item);
          }
          await sleep(60);
        }
      }

      await sleep(120);
    }

    return { addedByVariant, failedItems };
  }

  function ensureDeckbuilderToastHost() {
    let host = document.getElementById('deckbuilder-toast-host');
    if (!host) {
      host = document.createElement('div');
      host.id = 'deckbuilder-toast-host';
      host.className = 'deckbuilder-toast-host';
      document.body.appendChild(host);
    }
    return host;
  }

  function showDeckbuilderToast(message, type = 'info', timeoutMs = TOAST_TIMEOUT_MS) {
    const host = ensureDeckbuilderToastHost();
    const toast = document.createElement('div');
    toast.className = `deckbuilder-toast ${type}`;
    toast.textContent = message;
    host.appendChild(toast);

    requestAnimationFrame(() => {
      toast.classList.add('show');
    });

    setTimeout(() => {
      toast.classList.remove('show');
      setTimeout(() => {
        toast.remove();
      }, 180);
    }, timeoutMs);
  }

  function setButtonLoading(buttonEl, isLoading, loadingLabel, idleLabel) {
    if (!buttonEl) return;
    buttonEl.disabled = isLoading;
    buttonEl.classList.toggle('is-loading', isLoading);
    buttonEl.textContent = isLoading ? loadingLabel : idleLabel;
  }

  function displayResults() {
    ensureMixToggleUi();
    updateMixToggleUiState();

    // Update summary
    foundCount.textContent = `${searchResults.length} found`;
    missingCount.textContent = `${missingCards.length} missing`;
    totalPrice.textContent = `$${totalCost.toFixed(2)} total`;

    // Enable/disable add all button
    addAllBtn.disabled = searchResults.length === 0;

    // Display found cards
    resultsGrid.innerHTML = '';
    searchResults.forEach((result, index) => {
      const cardElement = createCardElement(result, index);
      resultsGrid.appendChild(cardElement);
    });

    // Display missing cards
    if (missingCards.length > 0) {
      missingList.innerHTML = '';
      missingCards.forEach(card => {
        const missingElement = createMissingCardElement(card);
        missingList.appendChild(missingElement);
      });
      missingCardsSection.style.display = 'block';
    } else {
      missingCardsSection.style.display = 'none';
    }

    showResults();
  }

  function createCardElement(result, index) {
    const cardDiv = document.createElement('div');
    cardDiv.className = 'deckbuilder-card found';
    cardDiv.style.animationDelay = `${index * 0.1}s`;

    const totalPrice = (result.price * result.quantity).toFixed(2);
    const conditionLabel = result.variant && result.variant.title ? result.variant.title : 'Condition not specified';
    const hasKnownQty = result.variant
      && result.variant.inventory_quantity !== null
      && result.variant.inventory_quantity !== undefined
      && Number.isFinite(Number(result.variant.inventory_quantity));
    const stockLabel = hasKnownQty
      ? `${Math.max(0, Number(result.variant.inventory_quantity))} available`
      : (result.stockStatus === 'pending' ? 'Checking stock...' : 'In stock');
    const availableVariants = result.product && Array.isArray(result.product.variants)
      ? result.product.variants.filter(v => v && v.available)
      : [];
    const variantOptionsHtml = availableVariants.length > 0
      ? availableVariants.map((variant) => {
          const selected = String(variant.id) === String(result.variantId) ? 'selected' : '';
          const variantPrice = Number(variant.price || 0) / 100;
          return `<option value="${variant.id}" data-price="${variantPrice}" ${selected}>${variant.title}</option>`;
        }).join('')
      : `<option value="${result.variantId}" selected>${conditionLabel}</option>`;

    cardDiv.innerHTML = `
      <div class="card-quantity">${result.quantity}x</div>
      ${result.image ? `<img src="${result.image}" alt="${result.title}" class="card-image">` : '<div class="card-image"></div>'}
      <div class="card-info">
        <h3>${result.title}</h3>
        <div class="card-price">$${result.price.toFixed(2)} each</div>
        <div class="card-variant-selector">
          <label for="variant-select-${index}">Condition</label>
          <select id="variant-select-${index}" onchange="updateCardVariant(${index}, this.value)">
            ${variantOptionsHtml}
          </select>
        </div>
        <div class="card-condition-stock">${conditionLabel} • ${stockLabel}</div>
        <div class="card-variant-info">Total: $${totalPrice}</div>
        <div class="card-actions">
          <button type="button" class="btn btn-primary btn-small" onclick="addSingleCardToCart('${result.variantId}', ${result.quantity}, this)">
            Add to Cart
          </button>
          <button type="button" class="btn btn-secondary btn-small" onclick="showAlternatives('${result.originalCardName}', ${index})">
            Alternatives
          </button>
          <a href="${result.url}" class="btn btn-secondary btn-small" target="_blank">View Product</a>
        </div>
      </div>
    `;

    return cardDiv;
  }

  function createMissingCardElement(card) {
    const cardDiv = document.createElement('div');
    cardDiv.className = 'missing-card-item';

    cardDiv.innerHTML = `
      <div class="card-name">${card.cardName}</div>
      <span class="card-quantity">${card.quantity}x</span>
    `;

    return cardDiv;
  }

  async function addAllFoundCardsToCart() {
    if (searchResults.length === 0) return;

    addAllBtn.disabled = true;
    addAllBtn.textContent = 'Adding to Cart...';

    try {
      const cart = await fetch('/cart.js').then(r => r.json());
      const inCartQtyMap = getInCartQuantityMap(cart);
      const allowMixedConditions = getAllowMixedConditions();
      const plannedResults = [];
      const shortfalls = [];
      const aggregatedByVariant = new Map();
      
      for (const result of searchResults) {
        try {
          const productData = await getProductDataForResult(result);
          const plan = buildAddPlan(
            productData,
            result.quantity,
            inCartQtyMap,
            allowMixedConditions,
            result.variantId
          );

          if (!plan.lines.length) {
            shortfalls.push(`${result.title}: out of stock`);
            continue;
          }

          for (const line of plan.lines) {
            const key = String(line.variantId);
            const existingPlannedQty = Number(aggregatedByVariant.get(key) || 0);
            aggregatedByVariant.set(key, existingPlannedQty + Number(line.quantity || 0));

            // Reserve in cart map while planning to avoid over-allocating the same variant.
            const existingCartQty = Number(inCartQtyMap.get(key) || 0);
            inCartQtyMap.set(key, existingCartQty + Number(line.quantity || 0));
          }

          plannedResults.push({
            title: result.title,
            requestedQty: plan.requestedQty,
            lines: plan.lines
          });
          
          // Small delay to prevent overwhelming the server
          await sleep(50);
        } catch (error) {
          console.error(`Error adding ${result.title}:`, error);
        }
      }

      const batchedItems = Array.from(aggregatedByVariant.entries()).map(([variantId, quantity]) => ({
        id: variantId,
        quantity
      }));

      const { addedByVariant, failedItems } = await addCartItemsInChunks(batchedItems);

      // Attribute added quantities back to each planned result (handles shared variants deterministically).
      const remainingAddedByVariant = new Map(addedByVariant);
      let successCount = 0;
      for (const planned of plannedResults) {
        let entryAdded = 0;
        for (const line of planned.lines) {
          const key = String(line.variantId);
          const availableAdded = Number(remainingAddedByVariant.get(key) || 0);
          const useQty = Math.min(availableAdded, Number(line.quantity || 0));
          if (useQty > 0) {
            entryAdded += useQty;
            remainingAddedByVariant.set(key, availableAdded - useQty);
          }
        }

        if (entryAdded > 0) successCount++;
        if (entryAdded < planned.requestedQty) {
          shortfalls.push(`${planned.title}: added ${entryAdded}/${planned.requestedQty}`);
        }
      }

      if (failedItems.length > 0) {
        shortfalls.push(`${failedItems.length} cart line(s) failed after retries`);
      }

      if (successCount > 0) {
        addAllBtn.textContent = `Added ${successCount} Cards`;
        addAllBtn.className = 'btn btn-success btn-large';
        
        // Update cart count and trigger notifications
        await updateCartCount();
        
        if (shortfalls.length > 0) {
          showDeckbuilderToast(`Some quantities were capped by stock (${shortfalls.length} items).`, 'warning', 4200);
        } else {
          showDeckbuilderToast('All cards were added to cart.', 'success');
        }
        setTimeout(() => {
          addAllBtn.disabled = false;
          addAllBtn.textContent = 'Add All Found Cards to Cart';
          addAllBtn.className = 'btn btn-success btn-large';
        }, 1600);
      } else {
        throw new Error('No cards could be added to cart');
      }
    } catch (error) {
      console.error('Error adding to cart:', error);
      showDeckbuilderToast('Error adding cards to cart. Please try again.', 'error');
      addAllBtn.disabled = false;
      addAllBtn.textContent = 'Add All Found Cards to Cart';
    }
  }

  // Function to update cart count
  async function updateCartCount() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      
      // Update cart count in various places
      const cartCountElements = document.querySelectorAll('[data-cart-count], .cart-count, #sticky-cart-count, .cart-count-bubble');
      cartCountElements.forEach(element => {
        element.textContent = cart.item_count;
      });
      
      // Trigger cart update events
      // Keep deckbuilder toast-only UX: avoid dispatching global cart events that can trigger theme popups.
      
      return cart;
    } catch (error) {
      console.error('Error updating cart count:', error);
    }
  }

  // Global function for individual card add to cart
  window.addSingleCardToCart = async function(variantId, quantity, buttonEl) {
    const idleLabel = 'Add to Cart';
    try {
      setButtonLoading(buttonEl, true, 'Adding...', idleLabel);
      const target = searchResults.find(r => String(r.variantId) === String(variantId));
      if (!target) {
        throw new Error('Card not found in current results');
      }

      const productData = await getProductDataForResult(target);
      const cart = await fetch('/cart.js').then(r => r.json());
      const inCartQtyMap = getInCartQuantityMap(cart);
      const allowMixedConditions = getAllowMixedConditions();
      const plan = buildAddPlan(
        productData,
        quantity,
        inCartQtyMap,
        allowMixedConditions,
        target.variantId
      );

      if (!plan.lines.length) {
        showDeckbuilderToast('This card is currently out of stock.', 'warning');
        setButtonLoading(buttonEl, false, 'Adding...', idleLabel);
        return;
      }

      const singleItems = plan.lines.map(line => ({ id: String(line.variantId), quantity: line.quantity }));
      const { addedByVariant } = await addCartItemsInChunks(singleItems);
      const addedQty = Array.from(addedByVariant.values()).reduce((sum, qty) => sum + Number(qty || 0), 0);

      if (addedQty > 0) {
        // Update cart count and trigger notifications
        await updateCartCount();
        
        if (plan.remainingQty > 0) {
          setButtonLoading(buttonEl, false, 'Adding...', `Added ${plan.addedQty}/${plan.requestedQty}`);
          showDeckbuilderToast(`Only added ${plan.addedQty} of ${plan.requestedQty} due to stock limits.`, 'warning', 4200);
        } else {
          setButtonLoading(buttonEl, false, 'Adding...', 'Added');
          showDeckbuilderToast('Card added to cart.', 'success');
        }
        setTimeout(() => {
          setButtonLoading(buttonEl, false, 'Adding...', idleLabel);
        }, 1300);
      } else {
        throw new Error('Failed to add item to cart');
      }
    } catch (error) {
      console.error('Error adding to cart:', error);
      showDeckbuilderToast('Error adding card to cart. Please try again.', 'error');
      setButtonLoading(buttonEl, false, 'Adding...', 'Try Again');
      setTimeout(() => {
        setButtonLoading(buttonEl, false, 'Adding...', idleLabel);
      }, 1300);
    }
  };

  window.updateCardVariant = async function(resultIndex, variantId) {
    const result = searchResults[resultIndex];
    if (!result) return;

    try {
      const productData = await getProductDataForResult(result);
      if (!productData || !Array.isArray(productData.variants)) return;

      const selectedVariant = productData.variants.find(v => String(v.id) === String(variantId));
      if (!selectedVariant) return;

      searchResults[resultIndex] = {
        ...result,
        product: productData,
        variant: selectedVariant,
        variantId: selectedVariant.id,
        price: Number(selectedVariant.price || 0) / 100
      };

      totalCost = searchResults.reduce((sum, item) => sum + (item.price * item.quantity), 0);
      displayResults();
    } catch (error) {
      console.error('Error updating selected variant:', error);
      showDeckbuilderToast('Could not switch variant. Please try again.', 'error');
    }
  };

  function showLoading() {
    loadingIndicator.style.display = 'block';
    resultsSection.style.display = 'none';
    searchBtn.disabled = true;
    searchBtn.textContent = 'Searching...';
  }

  function hideLoading() {
    loadingIndicator.style.display = 'none';
    searchBtn.disabled = false;
    searchBtn.textContent = 'Search Cards';
  }

  function showResults() {
    // Hide input section and show results
    inputSection.style.display = 'none';
    resultsSection.style.display = 'block';
  }

  function hideResults() {
    resultsSection.style.display = 'none';
    addAllBtn.disabled = true;
    addAllBtn.textContent = 'Add All Found Cards to Cart';
    addAllBtn.className = 'btn btn-success btn-large';
  }

  function showInputSection() {
    inputSection.style.display = 'block';
  }

  function hideInputSection() {
    inputSection.style.display = 'none';
  }

  // Initialize stats
  updateInputStats();

  // Sample deck list for demonstration
  const sampleDeck = `2 Island
3 Forest
Counterspell
Lightning Bolt
4 Llanowar Elves
Giant Growth`;

  // Add sample deck button for testing
  const sampleBtn = document.createElement('button');
  sampleBtn.textContent = 'Load Sample Deck';
  sampleBtn.className = 'btn btn-secondary';
  sampleBtn.addEventListener('click', function() {
    deckInput.value = sampleDeck;
    updateInputStats();
  });
  
  document.querySelector('.deckbuilder-actions').appendChild(sampleBtn);

  // Global function to show alternatives
  window.showAlternatives = async function(cardName, resultIndex) {
    const modal = document.getElementById('alternatives-modal');
    const title = document.getElementById('alternatives-title');
    const grid = document.getElementById('alternatives-grid');
    const loading = document.getElementById('alternatives-loading');
    const pagination = document.getElementById('alternatives-pagination');
    
    title.textContent = `Alternatives for "${cardName}"`;
    modal.style.display = 'flex';
    loading.style.display = 'block';
    grid.innerHTML = '';
    if (pagination) {
      pagination.innerHTML = '';
      pagination.style.display = 'none';
    }
    
    try {
      alternativesState = {
        cardName,
        resultIndex,
        items: [],
        currentPage: 1,
        totalPages: 1,
        perPage: ALTERNATIVES_PER_PAGE
      };

      await loadAlternativesPage(1);
    } catch (error) {
      console.error('Error finding alternatives:', error);
      loading.style.display = 'none';
      if (pagination) {
        pagination.innerHTML = '';
        pagination.style.display = 'none';
      }
      grid.innerHTML = '<p style="text-align: center; padding: 2rem; color: #dc3545;">Error finding alternatives. Please try again.</p>';
    }
  };

  // Global function to close alternatives modal
  window.closeAlternativesModal = function() {
    document.getElementById('alternatives-modal').style.display = 'none';
    const pagination = document.getElementById('alternatives-pagination');
    if (pagination) {
      pagination.innerHTML = '';
      pagination.style.display = 'none';
    }
    alternativesState = null;
  };

  // Global function to swap card
  window.swapCard = async function(resultIndex, newProduct) {
    try {
      const current = searchResults[resultIndex];
      if (!current) return;

      // Alternatives payload can be minimal; hydrate full product/variants so selector + stock remain accurate.
      const hydratedProduct = await getProductDataForResult({
        product: newProduct.product,
        url: newProduct.url
      });

      let selectedVariant = null;
      if (hydratedProduct && Array.isArray(hydratedProduct.variants)) {
        selectedVariant = hydratedProduct.variants.find(v => String(v.id) === String(newProduct.variantId));
      }

      // Fallback to incoming variant payload if hydration failed.
      if (!selectedVariant) {
        selectedVariant = newProduct.variant || null;
      }

      const selectedPrice = selectedVariant && Number.isFinite(Number(selectedVariant.price))
        ? Number(selectedVariant.price) / 100
        : Number(newProduct.price || 0);

      // Update the search result with hydrated data.
      searchResults[resultIndex] = {
        ...current,
        product: hydratedProduct || newProduct.product || current.product,
        variant: selectedVariant || current.variant,
        title: (hydratedProduct && hydratedProduct.title) || newProduct.title || current.title,
        price: selectedPrice,
        image: (hydratedProduct && hydratedProduct.featured_image) || newProduct.image || current.image,
        url: (hydratedProduct && hydratedProduct.handle) ? `/products/${hydratedProduct.handle}` : (newProduct.url || current.url),
        variantId: selectedVariant ? selectedVariant.id : (newProduct.variantId || current.variantId)
      };

      // Recalculate total cost
      totalCost = searchResults.reduce((sum, result) => sum + (result.price * result.quantity), 0);

      // Update display
      displayResults();
      closeAlternativesModal();
      showDeckbuilderToast('Alternative selected.', 'success');
    } catch (error) {
      console.error('Error swapping alternative:', error);
      showDeckbuilderToast('Could not apply this alternative. Please try again.', 'error');
    }
  };

  async function loadAlternativesPage(page) {
    if (!alternativesState) return;

    const grid = document.getElementById('alternatives-grid');
    const loading = document.getElementById('alternatives-loading');
    const pagination = document.getElementById('alternatives-pagination');
    if (!grid || !loading || !pagination) return;

    loading.style.display = 'block';
    grid.innerHTML = '';
    pagination.style.display = 'none';
    pagination.innerHTML = '';

    const data = await fetchAlternativesPage(alternativesState.cardName, page);

    alternativesState.currentPage = data.page || page;
    alternativesState.totalPages = data.pages || 1;
    alternativesState.items = Array.isArray(data.results) ? data.results : [];

    loading.style.display = 'none';

    renderAlternativesPage(grid);
    renderAlternativesPagination(pagination);
  }

  async function fetchAlternativesPage(cardName, page) {
    const vendorSelect = document.getElementById('vendor-select');
    const selectedCollection = vendorSelect ? vendorSelect.value : '';
    const collectionName = selectedCollection ? getCollectionDisplayName(selectedCollection) : '';

    // Bias results toward the selected game; also try storefront product_type filtering if it matches your catalog.
    const q = collectionName ? `${cardName} ${collectionName}` : cardName;
    const searchParams = new URLSearchParams();
    searchParams.set('view', 'alternatives-json');
    searchParams.set('type', 'product');
    searchParams.set('options[prefix]', 'last');
    searchParams.set('filter.v.availability', '1');
    searchParams.set('q', q);
    searchParams.set('page', String(page));
    if (collectionName) {
      searchParams.set('filter.p.product_type', collectionName);
    }

    const url = `/search?${searchParams.toString()}`;

    const response = await fetch(url, { headers: { 'Accept': 'application/json' } });
    if (!response.ok) {
      return { page, pages: 1, results: [] };
    }

    try {
      return await response.json();
    } catch (e) {
      return { page, pages: 1, results: [] };
    }
  }

  function goToAlternativesPage(page) {
    if (!alternativesState) return;
    loadAlternativesPage(page);
  }

  function renderAlternativesPage(gridEl) {
    const { items, cardName, resultIndex } = alternativesState;

    gridEl.innerHTML = '';

    if (!items || items.length === 0) {
      gridEl.innerHTML = '<p style="text-align: center; padding: 2rem; color: rgba(var(--color-foreground), 0.6);">No alternatives found for this card.</p>';
      return;
    }

    items.forEach((alt, index) => {
      const altElement = createAlternativeElement(alt, cardName, resultIndex, index);
      gridEl.appendChild(altElement);
    });
  }

  function renderAlternativesPagination(paginationEl) {
    const totalPages = Math.max(1, alternativesState.totalPages || 1);
    const currentPage = Math.min(totalPages, Math.max(1, alternativesState.currentPage || 1));

    paginationEl.innerHTML = '';

    if (totalPages <= 1) {
      paginationEl.style.display = 'none';
      return;
    }

    paginationEl.style.display = 'flex';

    const prevBtn = document.createElement('button');
    prevBtn.type = 'button';
    prevBtn.className = 'pagination-btn';
    prevBtn.textContent = 'Prev';
    prevBtn.disabled = currentPage <= 1;
    prevBtn.addEventListener('click', () => goToAlternativesPage(currentPage - 1));
    paginationEl.appendChild(prevBtn);

    const pageTokens = getPageTokens(currentPage, totalPages);
    pageTokens.forEach((token) => {
      if (token === '…') {
        const ellipsis = document.createElement('span');
        ellipsis.className = 'alternatives-page-status';
        ellipsis.textContent = '…';
        paginationEl.appendChild(ellipsis);
        return;
      }

      const p = token;
      const pageBtn = document.createElement('button');
      pageBtn.type = 'button';
      pageBtn.className = `pagination-btn${p === currentPage ? ' active' : ''}`;
      pageBtn.textContent = String(p);
      pageBtn.addEventListener('click', () => goToAlternativesPage(p));
      paginationEl.appendChild(pageBtn);
    });

    const nextBtn = document.createElement('button');
    nextBtn.type = 'button';
    nextBtn.className = 'pagination-btn';
    nextBtn.textContent = 'Next';
    nextBtn.disabled = currentPage >= totalPages;
    nextBtn.addEventListener('click', () => goToAlternativesPage(currentPage + 1));
    paginationEl.appendChild(nextBtn);

    const status = document.createElement('span');
    status.className = 'alternatives-page-status';
    status.textContent = `Page ${currentPage} of ${totalPages}`;
    paginationEl.appendChild(status);
  }

  function getPageTokens(current, total) {
    // Windowed pagination: 1 … (current-1 current current+1) … total
    if (total <= 7) {
      return Array.from({ length: total }, (_, i) => i + 1);
    }

    const tokens = [1];
    const start = Math.max(2, current - 1);
    const end = Math.min(total - 1, current + 1);

    if (start > 2) tokens.push('…');
    for (let p = start; p <= end; p++) tokens.push(p);
    if (end < total - 1) tokens.push('…');

    tokens.push(total);
    return tokens;
  }

  function createAlternativeElement(alternative, originalCardName, resultIndex, index) {
    const altDiv = document.createElement('div');
    altDiv.className = 'alternative-card';
    altDiv.style.animationDelay = `${index * 0.1}s`;
    
    const quantity = searchResults[resultIndex].quantity;
    const totalPrice = (alternative.price * quantity).toFixed(2);

    altDiv.innerHTML = `
      ${alternative.image ? `<img src="${alternative.image}" alt="${alternative.title}" class="alternative-card-image">` : '<div class="alternative-card-image"></div>'}
      <h4>${alternative.title}</h4>
      <div class="alternative-card-price">$${alternative.price.toFixed(2)} each</div>
      <div class="alternative-card-variant">Total: $${totalPrice} (${quantity}x)</div>
      <div class="alternative-card-actions">
        <button type="button" class="btn btn-success btn-small" onclick="swapCard(${resultIndex}, ${JSON.stringify(alternative).replace(/"/g, '&quot;')})">
          Use This Card
        </button>
        <a href="${alternative.url}" class="btn btn-secondary btn-small" target="_blank">View</a>
      </div>
    `;

    return altDiv;
  }
});
